import _ from 'lodash'
import { CountriesStates } from '../../CountriesStates'
import PrimaryInsuranceTab from './PrimaryInsuranceTab'
import { connect, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { change } from 'redux-form'
import { insuranceLoad } from '../../../redux/actions/settingActions/insuranceActions'
import { publicInsuranceLoad, publicInsurancePlansLoad } from '../../../../redux/actions/public/InsuranceActions'
import { insurancePlansLoad } from '../../../redux/actions/settingActions/insurancePlansActions'

function InsuranceWrap(props) {
  const { template, isTemplate, isLongForm, form, formName, insurance } = props
  const dispatch = useDispatch()

  const [visionInsurancePlans, setVisionInsurancePlans] = useState([])
  const [secondaryInsurancePlans, setSecondaryInsurancePlans] = useState([])
  const [medicalInsurancePlans, setMedicalInsurancePlans] = useState([])
  const [tertiaryInsurancePlans, setTertiaryInsurancePlans] = useState([])
  const [visionSecondaryInsurancePlans, setVisionSecondaryInsurancePlans] = useState([])
  const [visionTertiaryInsurancePlans, setVisionTertiaryInsurancePlans] = useState([])

  const [visionInsurance, setVisionInsurance] = useState([])
  const [visionSecondaryInsurance, setVisionSecondaryInsurance] = useState([])
  const [visionTertiaryInsurance, setVisionTertiaryInsurance] = useState([])
  const [medicalInsurance, setMedicalInsurance] = useState([])
  const [secondaryInsurance, setSecondaryInsurance] = useState([])
  const [tertiaryInsurance, setTertiaryInsurance] = useState([])

  const formData = form[formName]?.values ?? {}
  const { relation_to_insured } = formData

  const primaryInsurerCountryData = _.find(CountriesStates, { countryName: formData?.primary_insurer?.address_attributes?.country })
  const primaryInsurerSelectedCountry = primaryInsurerCountryData && primaryInsurerCountryData.countryName
  const primaryInsurerRegions = primaryInsurerCountryData ? primaryInsurerCountryData.regions : []

  const selectedVisionInsuranceId = formData?.patient_vision_insurance_attributes?.settings_insurance_id
  const selectedVisionSecondaryInsuranceId = formData?.patient_vision_secondary_insurance_attributes?.settings_insurance_id
  const selectedVisionTertiaryInsuranceId = formData?.patient_vision_tertiary_insurance_attributes?.settings_insurance_id
  const selectedMedicalInsuranceId = formData?.patient_medical_insurance_attributes?.settings_insurance_id
  const selectedSecondaryInsuranceId = formData?.patient_secondary_insurance_attributes?.settings_insurance_id
  const selectedTertiaryInsuranceId = formData?.patient_tertiary_insurance_attributes?.settings_insurance_id

  const handleInsurancePlansLoad = (filters) => {
    if (localStorage.getItem('Access-Token'))
      return dispatch(insurancePlansLoad(filters));
    else return dispatch(publicInsurancePlansLoad(filters));
  }

  const handleInsuranceLoad = (id) => {
    if (localStorage.getItem('Access-Token'))
      return dispatch(insuranceLoad(id));
    else return dispatch(publicInsuranceLoad(id));
  }

  useEffect(() => {
    if (selectedVisionInsuranceId) {
      handleInsuranceLoad(selectedVisionInsuranceId).then((res) => setVisionInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedVisionInsuranceId } })
        .then(res => setVisionInsurancePlans(res.value.data.insurance_plans))
    }
    if (selectedMedicalInsuranceId) {
      handleInsuranceLoad(selectedMedicalInsuranceId).then((res) => setMedicalInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedMedicalInsuranceId } })
        .then(res => setMedicalInsurancePlans(res.value.data.insurance_plans))
    }
    if (selectedSecondaryInsuranceId) {
      handleInsuranceLoad(selectedSecondaryInsuranceId).then((res) => setSecondaryInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedSecondaryInsuranceId } })
        .then(res => setSecondaryInsurancePlans(res.value.data.insurance_plans))
    }
    if (selectedTertiaryInsuranceId) {
      handleInsuranceLoad(selectedTertiaryInsuranceId).then((res) => setTertiaryInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedTertiaryInsuranceId } })
        .then(res => setTertiaryInsurancePlans(res.value.data.insurance_plans))
    }
    if (selectedVisionSecondaryInsuranceId) {
      handleInsuranceLoad(selectedVisionSecondaryInsuranceId).then((res) => setVisionSecondaryInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedVisionSecondaryInsuranceId } })
        .then(res => setVisionSecondaryInsurancePlans(res.value.data.insurance_plans))
    }
    if (selectedVisionTertiaryInsuranceId) {
      handleInsuranceLoad(selectedVisionTertiaryInsuranceId).then((res) => setVisionTertiaryInsurance(res.value.data.insurance))
      handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedVisionTertiaryInsuranceId } })
        .then(res => setVisionTertiaryInsurancePlans(res.value.data.insurance_plans))
    }
  }, [selectedVisionInsuranceId, selectedVisionSecondaryInsuranceId, selectedVisionTertiaryInsuranceId, selectedMedicalInsuranceId, selectedSecondaryInsuranceId, selectedTertiaryInsuranceId])

  const copyToInsurerAddress = (source, destination) => {
    const sourceObj = eval(`formData.${source}`);
    if (sourceObj) {
      const insurenceAddressValue = sourceObj[`address1`]
      const insurenceAddress2Value = sourceObj[`address2`]
      const insurenceCountryValue = sourceObj[`country`]
      const insurenceStateValue = sourceObj[`state`]
      const insurenceCityValue = sourceObj[`city`]
      const insurenceZipCodeValue = sourceObj[`zip`]
      return [
        dispatch(change('patientForm', `${destination}[address_attributes][address1]`, insurenceAddressValue)),
        dispatch(change('patientForm', `${destination}[address_attributes][address2]`, insurenceAddress2Value)),
        dispatch(change('patientForm', `${destination}[address_attributes][country]`, insurenceCountryValue)),
        dispatch(change('patientForm', `${destination}[address_attributes][state]`, insurenceStateValue)),
        dispatch(change('patientForm', `${destination}[address_attributes][city]`, insurenceCityValue)),
        dispatch(change('patientForm', `${destination}[address_attributes][zip]`, insurenceZipCodeValue)),
      ]
    }
  }

  return (
    <div id="patient-primary-insurance-tab">
      <PrimaryInsuranceTab
        template={template}
        formName={formName}
        insurance={insurance}
        isTemplate={isTemplate}
        isLongForm={isLongForm}
        patientRelationship={relation_to_insured}
        primaryInsurerSelectedCountry={primaryInsurerSelectedCountry}
        primaryInsurerRegions={primaryInsurerRegions}
        copyToInsurerAddress={copyToInsurerAddress}

        selectedVisionInsuranceId={selectedVisionInsuranceId}
        selectedVisionSecondaryInsuranceId={selectedVisionSecondaryInsuranceId}
        selectedVisionTertiaryInsuranceId={selectedVisionTertiaryInsuranceId}
        selectedMedicalInsuranceId={selectedMedicalInsuranceId}
        selectedSecondaryInsuranceId={selectedSecondaryInsuranceId}
        selectedTertiaryInsuranceId={selectedTertiaryInsuranceId}

        visionInsurancePlans={visionInsurancePlans}
        secondaryInsurancePlans={secondaryInsurancePlans}
        medicalInsurancePlans={medicalInsurancePlans}
        tertiaryInsurancePlans={tertiaryInsurancePlans}
        visionSecondaryInsurancePlans={visionSecondaryInsurancePlans}
        visionTertiaryInsurancePlans={visionTertiaryInsurancePlans}

        selectedVisionInsurance={visionInsurance}
        selectedMedicalInsurance={medicalInsurance}
        selectedSecondaryInsurance={secondaryInsurance}
        selectedTertiaryInsurance={tertiaryInsurance}
        selectedVisionSecondaryInsurance={visionSecondaryInsurance}
        selectedVisionTertiaryInsurance={visionTertiaryInsurance}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { form, setting: { insurance } } = state
  return {
    insurance: insurance.insurance,
    form
  }
}

export default connect(mapStateToProps)(InsuranceWrap);